import React, { Component } from 'react';
import * as $ from 'jquery';
import calendar from '../../images/calendar.png';
import office from '../../images/office.png';
import search from '../../images/search.png';
import brandLogo from '../../images/brand-logo-inverse-dark.png';
import { SECTION } from '../../onboarding/OnboardingContainer.js';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import { LANG } from '../../App.js';

class Store extends Component {

  renderCenter = (center, index) => {
    return (
      <li key={index}>
        <a onClick={() => this.props.handleCenterClick(center)}>
          {center.name}
        </a>
      </li>
    );
  }

  render() {
    const { t } = this.props;
    return (
      <div className="login-panel panel panel-default">
        <div className="panel-content">
          <div className="panel-heading-signup text-center">
            <img height="64px" alt="IOS OFFICES" src={brandLogo} />
          </div>
          <div className="panel-body-singup">
            <h1 className="heading">{t('guest.store.heading')}</h1>
            <h3 className="subheading">{t('guest.store.subheading')}</h3>
            <form className="form-group" method="post">
              <fieldset className="container-fluid">
                <div className="row">
                  <div className="col-sm-10 col-sm-offset-1">
                    <div className="form-group">
                      <div className="input-group">
                        <div id="dropdown-div" className="dropdown">
                          <input
                            autoComplete="off"
                            className="dropdown-toggle form-control input-lg"
                            data-toggle="dropdown"
                            onChange={this.props.handleCenterSearch}
                            onClick={() => { $("#dropdown-div").addClass("open") }}
                            placeholder={t('guest.store.holder_center')}
                            required
                            type="search"
                            value={this.props.centerQuery}
                            style={{ float: 'none' }}
                          />
                          <ul id="center-results" className="dropdown-menu" style={{ display: 'none' }}>
                            {this.props.centers.map((center, index) => this.renderCenter(center, index))}
                          </ul>
                        </div>
                        <div className="input-group-btn">
                          <Link to="/store/reservations">
                            <button
                              className="btn btn-lg btn-primary btn-singup"
                              type="button">
                              <span><i className="glyphicon glyphicon-search" style={{ fontSize: "12pt" }} /></span>
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
          <div className="container-fluid container-padding text-center container-desktop">
            <h4>{t('guest.store.help')}</h4>
            <div className="row">
              <div className="col-xs-8 col-xs-offset-2 col-sm-10 col-sm-offset-1">
                <div className="row">
                  <div className="col-md-4">
                    <img alt={t('guest.store.img_calendar')} className="icon-accent" src={calendar} />
                    <h4 className="text-primary text-heding">{t('guest.store.step1.heading')}</h4>
                    <p className="text-primary text-container">{t('guest.store.step1.body')}</p>
                  </div>
                  <div className="col-md-4">
                    <img alt={t('guest.store.img_office')} className="icon-accent" src={office} />
                    <h4 className="text-primary">{t('guest.store.step2.heading')}</h4>
                    <p>{t('guest.store.step2.body')}</p>
                  </div>
                  <div className="col-md-4">
                    <img alt={t('guest.store.img_search')} className="icon-accent" src={search} />
                    <h4 className="text-primary">{t('guest.store.step3.heading')}</h4>
                    <p>{t('guest.store.step3.body')}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="panel-footer-signup">
            <div className="movil_container">
              <div className="form-group">
                <Link className="nav-link" to="/onboarding">
                  <button
                    className="btn btn-block btn-primary  btn-singup btn_create btn_color">
                    {t('guest.navbar.login')}
                  </button>
                </Link>
              </div>
              <div className="form-group">
                <Link className="nav-link" to={{ pathname: "/onboarding", state: { section: SECTION.SIGNUP } }}>
                  <button className="btn btn-block btn-primary btn-singup btn_resser btn_color">
                    {t('guest.navbar.signup')}
                  </button>
                </Link>
              </div>
              <div className="form-group">
                <button type="button" className="btn btn-block btn-primary btn-singup btn_create btn_color" data-toggle="modal" data-target=".bs-example-modal-lg">
                  {t('guest.store.help')}
                </button>
              </div>
              <div className="col-md-4 col-md-offset-4">
                <div className="change-lenguage-text LanguageChange">
                  <a onClick={this.props.handleLanguageChange}>
                    {this.props.lang === LANG.EN ? "ESPAñOL" : "ENGLISH"}
                  </a>
                </div>
              </div>
            </div>
            <div className="modal fade bs-example-modal-lg" tabIndex="-1" role="dialog" aria-labelledby="myLargeModalLabel">
              <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span
                      aria-hidden="true">&times;</span></button>
                    <h4 className="modal-title" id="exampleModalLabel">{t('guest.store.help')}</h4>
                  </div>
                  <div className="modal-body">
                    <div id="carousel-example-generic" className="carousel slide" data-ride="carousel">
                      <ol className="carousel-indicators">
                        <li data-target="#carousel-example-generic" data-slide-to="0" className="active"></li>
                        <li data-target="#carousel-example-generic" data-slide-to="1"></li>
                        <li data-target="#carousel-example-generic" data-slide-to="2"></li>
                      </ol>
                      <div className="carousel-inner" role="listbox">
                        <div className="item active">
                          <div className="col-md-4">
                            <img alt={t('guest.store.img_calendar')} className="icon-accent" src={calendar} />
                            <h4 className="text-primary">{t('guest.store.step1.heading')}</h4>
                            <p>{t('guest.store.step1.body')}</p>
                          </div>
                        </div>
                        <div className="item">
                          <div className="col-md-4">
                            <img alt={t('guest.store.img_office')} className="icon-accent" src={office} />
                            <h4 className="text-primary">{t('guest.store.step2.heading')}</h4>
                            <p>{t('guest.store.step2.body')}</p>
                          </div>
                        </div>
                        <div className="item" >
                          <div className="col-md-4">
                            <img alt={t('guest.store.img_search')} className="icon-accent" src={search} />
                            <h4 className="text-primary">{t('guest.store.step3.heading')}</h4>
                            <p>{t('guest.store.step3.body')}</p>
                          </div>
                        </div>
                      </div>
                      <a className="left carousel-control" href="#carousel-example-generic" role="button" data-slide="prev">
                        <span className="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
                        <span className="sr-only">Previous</span>
                      </a>
                      <a className="right carousel-control" href="#carousel-example-generic" role="button" data-slide="next">
                        <span className="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
                        <span className="sr-only">Next</span>
                      </a>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div >
    );
  }
}

export default translate('common')(Store);



// WEBPACK FOOTER //
// ./src/guest/store/Store.js